import { Link } from "react-router-dom";
import { H1 } from "../../components/basics";
import cls from "../../utils/cls";
import { useTranslation } from "react-i18next";
import Header from "../auth/layout/Header";
import TravelFooter from "../travel/TravelFooter";

const Main = () => {
  const { t } = useTranslation("pages", { keyPrefix: "contractor.navigation" });

  return (
    <div className="flex flex-col justify-start min-h-[inherit]">
      <Header home="/contractor" />
      <main className={cls("container-flow flex flex-grow flex-col gap-4 mt-16")}>
        <H1 className=" font-serif font-bold text-xl md:text-2xl"> Foreign Worker Bond</H1>
        <ul className=" text-red font-bold underline gap-4 flex flex-col">
          <Link key="create-contractor" to="/contractor/new/contractor-details">
            {t("newContractor")}
          </Link>
          <Link key="contractor-listing" to="/contractor-list">
            {t("contractorListing")}
          </Link>
          <Link key="insured-listing" to="/insured-list">
            {t("workerListing")}
          </Link>
        </ul>
      </main>
      <TravelFooter />
    </div>
  );
};

export default Main;
